import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { ISSUE_RESTRICTION_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformJiraRoleToRestriction = (role) => {
	if (role == null) return null;
	return { restrictionValue: role.roleId };
};

export const transformAggIssueRestrictionToLegacyField: FieldTransformer<
	typeof ISSUE_RESTRICTION_TYPE
> = (node, projectContext) => {
	if (node.type !== ISSUE_RESTRICTION_TYPE) return undefined;

	const roles = transformAggConnection(
		node.selectedRolesConnection,
		transformJiraRoleToRestriction,
	);

	const restrictions = roles.length > 0 ? { projectrole: roles } : {};

	return {
		...transformAggNodeToLegacyField(node),
		value: {
			shouldDisplay: projectContext?.canSetIssueRestriction === true,
			issuerestrictions: restrictions,
		},
		schema: {
			configuration: null,
			items: null,
			renderer: PLAIN_TEXT,
			type: ISSUE_RESTRICTION_TYPE,
			custom: null,
			system: node.type,
		},
	};
};
